module.exports = __webpack_public_path__ + "components/flag/static/square/cu-213082541b3afdb651656a2edf87cc46.svg";